'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/services', {
      template: require('./services.pug'),
      controller: 'ServicesController',
      controllerAs: 'services',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/services/services.routes.ts